import React, { useEffect, useState } from "react";
import { SketchPicker } from "react-color"; 

const ColorPicker = ({ color, setColor, onChangeComplete }) => {
    const [showPicker, setShowPicker] = useState(false);
    const uniqueId = React.useId(); 

    // Handle outside messages to close picker
    useEffect(() => {
        const handleGlobalClose = (event) => {
            if (event.detail !== uniqueId) {
                setShowPicker(false); 
            }
        };

        window.addEventListener("closeAllColorPickers", handleGlobalClose);
        return () => {
            window.removeEventListener("closeAllColorPickers", handleGlobalClose);
        };
    }, [uniqueId]);

    const handleColorChange = (updatedColor) => {
        setColor(updatedColor.hex);
        if (onChangeComplete) {
            onChangeComplete(updatedColor);
        }
    };

    const togglePicker = () => {
        if (!showPicker) {
            // Close all other pickers
            window.dispatchEvent(new CustomEvent("closeAllColorPickers", { detail: uniqueId }));
        }
        setShowPicker(!showPicker);
    };


    return (
        <div>
            <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                <button type="button"
                    onClick={togglePicker}
                    style={{
                        background: color,
                        width: "40px",
                        height: "40px",
                        border: "1px solid #ccc",
                        cursor: "pointer",
                        borderRadius: "4px"
                    }}
                ></button>
            </div>

            {showPicker && (
                <div className="pickar-box-color" style={{ position: "absolute", zIndex: 2 }}>
                    <div className="header-picker">
                        Color
                        <button type="button"
                            className="close-button-color" 
                            onClick={() => setShowPicker(false)}
                            style={{ marginTop: "10px" }}
                        >
                            Done
                        </button>
                    </div>
                    <SketchPicker 
                        color={color} 
                        onChange={handleColorChange} 
                    />
                </div>
            )}
        </div>
    );
};
 
export default ColorPicker;
